import { render, staticRenderFns } from "./Ceremoni.vue?vue&type=template&id=b8e85550&"
import script from "./Ceremoni.vue?vue&type=script&lang=js&"
export * from "./Ceremoni.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports